if (window.__cepCalcRegistered) {
  // already registered
} else {
  window.__cepCalcRegistered = true;

  const ZONES = {
    SP: {
      label: 'SP',
      methods: [
        { name: 'Frete Fixo', price: 14.80, days: 6 },
        { name: 'Frete Grátis', price: 0, days: 6, freeOver: 500 }
      ]
    },
    Sudeste: {
      label: 'Sudeste',
      states: ['ES', 'MG', 'RJ'],
      methods: [
        { name: 'PAC', price: 16.80, days: 12 },
        { name: 'Sedex', price: 26.80, days: 6 },
        { name: 'PAC Grátis', price: 0, days: 12, freeOver: 500 }
      ]
    },
    SulCentro: {
      label: 'Sul e Centro',
      states: ['DF', 'GO', 'MT', 'MS', 'PR', 'RS', 'SC'],
      methods: [
        { name: 'PAC', price: 18.80, days: 12 },
        { name: 'Sedex', price: 29.80, days: 6 },
        { name: 'PAC Grátis', price: 0, days: 12, freeOver: 500 }
      ]
    },
    NordesteNorte: {
      label: 'Nordeste e Norte',
      states: ['AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'MA', 'PA', 'PB', 'PE', 'PI', 'RN', 'RO', 'RR', 'SE', 'TO'],
      methods: [
        { name: 'PAC', price: 22.80, days: 14 },
        { name: 'Sedex', price: 43.80, days: 7 },
        { name: 'PAC Grátis', price: 0, days: 14, freeOver: 500 }
      ]
    }
  };

  const STATE_TO_ZONE = (function () {
    const map = { SP: 'SP' };
    Object.keys(ZONES).forEach(function (key) {
      const z = ZONES[key];
      if (!z.states) return;
      z.states.forEach(function (s) { map[s] = key; });
    });
    return map;
  })();

  function formatBRL(n) {
    return 'R$ ' + n.toFixed(2).replace('.', ',');
  }

  function renderResult(data, productPrice) {
    const zoneKey = STATE_TO_ZONE[data.uf];
    if (!zoneKey) {
      return '<p class="cep-calculator__error">Não atendemos essa região no momento.</p>';
    }
    const zone = ZONES[zoneKey];
    const hitsFree = productPrice >= 500;

    let html = '<div class="cep-calculator__city">' + data.localidade + '/' + data.uf + ' · ' + zone.label + '</div>';
    html += '<ul class="cep-calculator__methods">';
    zone.methods.forEach(function (m) {
      const isFree = m.price === 0;
      if (isFree && !hitsFree) return;
      const label = isFree
        ? 'Grátis'
        : formatBRL(m.price);
      html += '<li>'
        + '<span class="cep-calculator__method-name">' + m.name + '</span>'
        + '<span class="cep-calculator__method-meta">' + label + ' · ' + m.days + ' dias úteis</span>'
        + '</li>';
    });
    html += '</ul>';
    return html;
  }

  function maskCep(input) {
    let v = input.value.replace(/\D/g, '').slice(0, 8);
    if (v.length > 5) v = v.slice(0, 5) + '-' + v.slice(5);
    input.value = v;
  }

  document.addEventListener('input', function (e) {
    if (e.target.matches('.cep-calculator__input')) {
      maskCep(e.target);
    }
  });

  document.addEventListener('submit', function (e) {
    if (!e.target.matches('.cep-calculator__form')) return;
    e.preventDefault();

    const form = e.target;
    const input = form.querySelector('.cep-calculator__input');
    const result = form.parentElement.querySelector('.cep-calculator__result');
    const cep = input.value.replace(/\D/g, '');

    if (cep.length !== 8) {
      result.innerHTML = '<p class="cep-calculator__error">CEP inválido. Use 8 dígitos.</p>';
      return;
    }

    result.innerHTML = '<p class="cep-calculator__loading">Calculando...</p>';

    const calc = form.closest('.cep-calculator');
    const productPrice = calc ? parseFloat(calc.getAttribute('data-product-price')) : 0;

    fetch('https://viacep.com.br/ws/' + cep + '/json/')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.erro) {
          result.innerHTML = '<p class="cep-calculator__error">CEP não encontrado.</p>';
          return;
        }
        result.innerHTML = renderResult(data, productPrice);
      })
      .catch(function () {
        result.innerHTML = '<p class="cep-calculator__error">Erro ao consultar o CEP. Tente novamente.</p>';
      });
  });
}
